import { CardNetwork } from "frontend-client";

export const getCardIconForPaze = (network?: CardNetwork | string) => {
  switch (network) {
    case "VISA":
      return "visa";
    case "MASTERCARD":
      return "mastercard";
    default:
      return "";
  }
};
